import React from 'react';
import { event } from '../data/masterclass';
export function FinalCta() {
  return <section aria-labelledby="final-cta-heading" className="bg-ink-soft" data-id="element-39" data-mp="vffvgpvh26si">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center px-6 py-16 text-center lg:py-20" data-id="element-40" data-mp="vhiu1yaox88u">
        <img src={event.logoUrl} alt="Meet the Eatmons" className="h-28 w-28 object-contain sm:h-32 sm:w-32" data-id="element-41" data-mp="15ddhr7trttih" />

        <h2 id="final-cta-heading" className="mt-10 font-display text-6xl font-bold uppercase leading-[0.95] text-gold sm:text-7xl lg:text-[7.5rem]" data-id="element-42" data-mp="1jbtylrlcl0ec">
          Built to
          <span className="block text-white" data-id="element-43" data-mp="1t1myvwg1ht3a">carry more.™</span>
        </h2>

        <p className="mt-10 text-sm font-semibold uppercase tracking-[0.14em] text-gold-pale" data-id="element-44" data-mp="1o3lftbim5trt">
          {event.eventLine}
        </p>

        <p className="mt-8 text-sm text-white/45" data-id="element-45" data-mp="2245wo24yxfio">
          Secure checkout · Replay included · Workbook included · Live Q&amp;A
        </p>
      </div>
    </section>;
}